'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavbarCollapse = require('react-bootstrap/lib/NavbarCollapse');

var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NavbarCollapse2.default;